import { filterCountyLocationAction, zipCityCountyConfigAction } from '@/actions/configActions'
import { defineStore } from 'pinia'

export const useRootStore = defineStore('root', {

  state: () => ({
    locationsURL: process.env.VUE_APP_LOCATIONS_URL,
    locationsURLsearch:process.env.VUE_APP_LOCATIONS_SEARCH_URL,
    iwtURL:process.env.VUE_APP_LOCATIONS_IWT_URL,
    wtcURL:process.env.VUE_APP_LOCATIONS_WTC_URL || '',
    wtcKey: process.env.VUE_APP_WTC_KEY || '',
    // Each IWT office has a top level unit number to start your query from
    itwTopLevelUnitDL: process.env.VUE_APP_IWT_TOP_UNIT_DL,
    itwTopLevelUnitLPA: process.env.VUE_APP_IWT_TOP_UNIT_LPA,
    itwTopLevelUnitIRP: process.env.VUE_APP_IWT_TOP_UNIT_IRP,
    itwTopLevelUnitLT: process.env.VUE_APP_IWT_TOP_UNIT_LT, 

    // Is today a state holiday?
    isStateHoliday:false,

    // IWT Allowed Dates and Times
    allowedDateTime: null,
    mapPollingInterval: null,
    iwtWaitIntervalTime: null,

    // Has IWT Loaded?
    isIWTLoaded:false,

    // Show Only Kiosk Layers
    // Special flag for query string loading of kiosk layers
    showOnlyKiosk:false,

    // Customer requested IWT not load before noon
    iwtLoadWindow:false,

    // Which counties allow kiosks at LPA offices?
    // As of April 2024, it was only Wake, Meck, and Cumberland counties:
    lpaKioskAllowed:[],

    // 
    mapMode:false,

    // Bing Maps
    mapAPIresponse:[],
    mapAPIkey:"",
    
    // Current location
    userLocation:"",

    zoomedLocation:[],

    // Loaded Office Data
    officekDLwithKiosks:[],
    officeDL:[],
    officeLPAwithKiosks:[],
    officeLPA:[],

    // Saturday offices
    officeDLSaturdayWithKiosks:[],
    officeDLSaturday:[],
    officeLPASaturday:[],

    // officeMO:[],
    officeIRP:[],
    officeLT:[],

    closedOfficeKioskDL:[],
    closedOfficeDL:[],
    closedOfficeKioskDLVR:[],
    closedOfficeKioskVR:[],
    closedOfficeLPA:[],
    closedOfficeIRP:[],
    closedOfficeLT:[],


    officesNearby:[],
    officesNearbySecondary:[],
    officesNearbyFurtherOut:[],
    dataLoaded:false,
    
    // Switches
    toggleDL:true,
    toggleLPA:true,
    // toggleMO:true,
    toggleIRP:false,
    toggleLT:false,
    toggleClosed:true,

    toggleDLSaturday:false,
    toggleKioskDL:true,
    toggleKioskVR:true,
    toggleKioskDLVR:true,

  
    primaryCard:[],
    searchData:[],

  }),
  getters: {
    getMapMode: state =>state.mapMode,
    getLocationsURL: state =>state.locationsURL,
    getLocationsURLsearch: state =>state.locationsURLsearch,
    
    mapAPIresponse: state =>state.mapAPIresponse,
    getMapAPIkey: state => state.mapAPIkey,
    getUserLocation: state => state.userLocation,
    getZoomedLocation: state => state.zoomedLocation,

    // IWT get Allowed Dates and Times

    getallowedDateTime: state => state.allowedDateTime,
    getIWTWaitIntervalTime: state => state.iwtWaitIntervalTime,
    getmapPollingInterval: state => state.mapPollingInterval,

    // Holiday status
    getIsStateHoliday: state => state.isStateHoliday,

    // Kiosks
    getShowOnlyKiosk: state => state.showOnlyKiosk,
    getLpaKioskAllowed: state => state.lpaKioskAllowed,

    // Offices
    getOfficekDLwithKiosks: state => state.officekDLwithKiosks,
    getOfficeDL: state => state.officeDL,

    getOfficeLPAwithKiosks: state => state.officeLPAwithKiosks,
    getOfficeLPA: state => state.officeLPA,


    getofficeDLSaturdayWithKiosks: state => state.officeDLSaturdayWithKiosks,
    getOfficeDLSaturday: state => state.officeDLSaturday,
    getOfficeLPASaturday: state => state.officeLPASaturday,

    getOfficeKAllKiosks: state =>state.officeKAllKiosks,
    getofficeKAllKiosksLPA: state =>state.officeKAllKiosksLPA,


    // getOfficeMO: state => state.officeMO,
    getOfficeLT: state => state.officeLT,
    getOfficeIRP: state => state.officeIRP,

    
    getClosedOfficeDL: state => state.closedOfficeDL,
    getClosedOfficeKioskDLVR: state => state.closedOfficeKioskDLVR,
    getClosedOfficeKioskVR: state => state.closedOfficeKioskVR,
    getClosedOfficeLPA: state => state.closedOfficeLPA,
    getClosedOfficeIRP: state => state.closedOfficeIRP,
    getClosedOfficeLT: state => state.closedOfficeLT,
    getClosedOfficeKioskDL: state => state.closedOfficeKioskDL,

  


    /* 
    getOfficeDL: state => state.officeDL,
    getOfficeLPA: state => state.officeLPA,
    // getOfficeMO: state => state.officeMO,
    getOfficeLT: state => state.officeLT,
    getOfficeIRP: state => state.officeIRP,

    getOfficeDLSaturday: state => state.officeDLSaturday,
    getOfficeLPASaturday: state => state.officeLPASaturday,

    getOfficeKioskDL:state =>state.officeKioskDL,
    getOfficeKioskVR: state =>state.officeKioskVR,
    getOfficeKioskDLVR: state =>state.officeKioskDLVR,
    
    getClosedOfficeDL: state => state.closedOfficeDL,
    getClosedOfficeLPA: state => state.closedOfficeLPA,
    // getClosedOfficeMO: state => state.closedOfficeMO,
    getClosedOfficeLT: state => state.closedOfficeLT,
    getClosedOfficeIRP: state => state.closedOfficeIRP,

    getClosedOfficeKioskDL:state =>state.closedOfficeKioskDL,
    getClosedOfficeKioskVR: state =>state.closedOfficeKioskVR,
    getClosedOfficeKioskDLVR: state =>state.closedOfficeKioskDLVR,

    */

    getOfficesNearby: state => state.officesNearby,
    getOfficesNearbySecondary: state => state.officesNearbySecondary,
    getOfficesNearbyFurtherOut: state => state.officesNearbyFurtherOut,    
    getDataLoaded: state => state.dataLoaded,
    getPrimaryCard:state => state.primaryCard,

    // Toggles
    getToggleDL:state => state.toggleDL,
    getToggleLPA:state => state.toggleLPA,
    // getToggleMO:state => state.toggleMO,
    getToggleIRP:state => state.toggleIRP,
    getToggleLT:state => state.toggleLT,
    getToggleClosed:state => state.toggleClosed,
    getToggleDLSaturday:state => state.toggleDLSaturday,
    getToggleDLkiosk:state => state.toggleKioskDL,
    getToggleVRkiosk:state => state.toggleKioskVR,
    getToggleDLVRkiosk:state => state.toggleKioskDLVR,

    
    getSearchData:state => state.searchData,

    // IWT
    getIWTTopLevelUnitDL:   state => state.itwTopLevelUnitDL,
    getIWTTopLevelUnitLPA:  state => state.itwTopLevelUnitLPA,
    getIWTTopLevelUnitIRP:  state => state.itwTopLevelUnitIRP,
    getIWTTopLevelUnitLT:   state => state.itwTopLevelUnitLT,
    getIWTLoadWindow:       state => state.iwtLoadWindow,
    getIsIWTLoaded:         state => state.isIWTLoaded,

    getWTCURL: state => state.wtcURL,
    getWTCKey: state => state.wtcKey,
  },
  
  actions: {
    //updateStoreData(storeToUpdate, data) {
      // if(storeToUpdate && data) {
      //   this[storeToUpdate](data);
      // }
    //},
    async fetchZipCityCountydata() {
      const fetchData = await zipCityCountyConfigAction(); // api call to get zip-city-county data
      this.SET_SEARCH_DATA(fetchData);
      if (location.search && fetchData) {
        const filteredCountyData = await filterCountyLocationAction(location.search, fetchData)
        this.SET_USER_LOCATION(filteredCountyData);
      }
    },
    clearClosedOfficeMode() {
      if (this.getMapMode) {
          this.SET_MAPMODE(false)
          const url = new URL(window.location.href);
          url?.searchParams.delete('mode');
          history.pushState({}, '', url.href)
      }
    },
    SET_LPAKIOSKALLOWED(data){
      this.lpaKioskAllowed = data
    },
    SET_ISSTATEHOLIDAY(data){
      this.isStateHoliday = data
    },
    SET_SHOWONLYKIOSK(data){
      this.showOnlyKiosk = data
    },
    SET_IWTLOADWINDOW(data){
      this.iwtLoadWindow = data
    },
    SET_ISIWTLOADED(data){
      this.isIWTLoaded = data
    },
    SET_MAPMODE(data){
      this.mapMode = data
    },
    SET_TIER_LOCATIONS_URL(data){
      this.locationsURL = data
    },
    SET_TIER_LOCATIONS_URL_SEARCH(data){
      this.locationsURLsearch = data
    },
    SET_TIER_LOCATIONS_IWT(data){
      this.iwtURL = data
    },
    UPDATE_MAP_API_KEY(data){
      this.mapAPIkey = data
    },
    SET_ALLOWED_IWT_DATE_TIME(data){
      this.allowedDateTime = data
    },
    SET_IWT_WAIT_INTERVAL_TIME(data){
      this.iwtWaitIntervalTime = data
    },
    SET_MAP_POLLING_INTERVAl(data){
      this.mapPollingInterval = data
    },

    SET_MAPAPI_RESPONSE(data){
      this.mapAPIresponse = data;
    },
    SET_SEARCH_DATA(data){
      this.searchData = data;
    },
    SET_USER_LOCATION(data){
      this.userLocation = data;
    },
    SET_ZOOMED_LOCATION(data){
      this.zoomedLocation = data;
    },
    CLEAR_NEARBY_OFFICES(data){
      this.officesNearby = data;
    },
    SET_NEARBY_OFFICES(data){
      this.officesNearby = data  // this one is good for geolocation
    },
    SET_NEARBY_OFFICES_SECONDARY(data){
      this.officesNearbySecondary = data;
    },
    SET_NEARBY_OFFICES_FURTHEROUT(data){
      this.officesNearbyFurtherOut = data;
    },
    SET_PRIMARY_CARD(data){
      this.primaryCard = data
    },
    TOGGLE_SWITCH_DL(data){
      this.toggleDL = data
    },
    TOGGLE_SWITCH_LPA(data){
      this.toggleLPA = data
    },
    // TOGGLE_SWITCH_MO:(state,data) =>{
    //   this.toggleMO = data
    // },
    TOGGLE_SWITCH_LT(data){
      this.toggleLT = data
    },
    TOGGLE_SWITCH_IRP(data){
      this.toggleIRP = data
    },
    // TOGGLE_SWITCH_APT:(state,data) =>{
    //   this.toggleApt = data
    // },
    TOGGLE_SWITCH_CLOSED(data){
      this.toggleClosed = data
    },
    TOGGLE_SWITCH_DL_SATURDAY(data){
      this.toggleDLSaturday = data
    },
    TOGGLE_SWITCH_KIOSK_DL(data){
      this.toggleKioskDL = data
    },
    TOGGLE_SWITCH_KIOSK_VR(data){
      this.toggleKioskVR = data
    },
    TOGGLE_SWITCH_KIOSK_DLVR(data){
      this.toggleKioskDLVR = data
    },
    SET_DATALOADED(data){
      this.dataLoaded = data
    },

    // DL data
    SET_OFFICE_DL_WITHKIOSKS(data){
      this.officekDLwithKiosks = data
    },
    SET_OFFICE_DL(data){
      this.officeDL = data
    },

    // LPA data
    SET_OFFICE_LPA_WITHKIOSKS(data){
      this.officeLPAwithKiosks = data
    },
    SET_OFFICE_LPA(data){
      this.officeLPA = data
    },


    // Saturdays
    SET_OFFICE_DL_SATURDAYWITHKIOSKS(data){
      this.officeDLSaturdayWithKiosks = data
    },
    SET_OFFICE_DL_SATURDAY(data){
      this.officeDLSaturday = data
    },

    // All Kiosks
    SET_OFFICE_ALL_KIOSKS(data){
      this.officeKAllKiosks = data
    },

    SET_OFFICE_ONLY_LPA_KIOSKS(data){
      this.officeKAllKiosksLPA = data
    },


    SET_OFFICE_IRP(data){
      this.officeIRP = data
    },
    SET_OFFICE_LT(data){
      this.officeLT = data
    },



    SET_OFFICE_DL_WITHKIOSKS_CLOSED(data){
      this.closedOfficeKioskDL = data
    },
    SET_OFFICE_DL_CLOSED(data){
      this.closedOfficeDL = data
    },
    SET_OFFICE_ALL_KIOSKS_CLOSED(data){
      this.closedOfficeKioskDLVR = data
    },
    SET_OFFICE_LPA_WITHKIOSKS_CLOSED(data){
      this.closedOfficeKioskVR = data
    },
    SET_OFFICE_LPA_CLOSED(data){
      this.closedOfficeLPA = data
    },
    SET_OFFICE_IRP_CLOSED(data){
      this.closedOfficeIRP = data
    },
    SET_OFFICE_LT_CLOSED(data){
      this.closedOfficeLT = data
    },


    /*
    SET_OFFICEDL: (state,data) =>{
      state.officeDL = data
    },
    SET_OFFICELPA: (state,data) =>{
      state.officeLPA = data
    },
    // SET_OFFICEMO: (state,data) =>{
    //   // state.officeMO = Object.assign({},data)
    //   // state.officeMO = [...state.officeMO, data]
    //   state.officeMO = data
    // },
    SET_OFFICEIRP: (state,data) =>{
      state.officeIRP = data
    },
    SET_OFFICELT: (state,data) =>{
      state.officeLT = data
    },

    SET_OFFICEKIOSKDL: (state,data) =>{
      state.officeKioskDL = data
    },

    SET_OFFICEKIOSKVR: (state,data) =>{
      state.officeKioskVR = data
    },

    SET_OFFICEKIOSKDLVR: (state,data) =>{
      state.officeKioskDLVR = data
    },

    SET_OFFICEDLSATURDAY: (state,data) =>{
      state.officeDLSaturday = data
    },
    SET_OFFICELPASATURDAY: (state,data) =>{
      state.officeLPASaturday = data
    },
    SET_CLOSEDOFFICEDL: (state,data) =>{
      state.closedOfficeDL = data
    },
    SET_CLOSEDOFFICELPA: (state,data) =>{
      state.closedOfficeLPA = data
    },
    // SET_CLOSEDOFFICEMO: (state,data) =>{
    //   // state.officeMO = Object.assign({},data)
    //   // state.officeMO = [...state.officeMO, data]
    //   state.closedOfficeMO = data
    // },
    SET_CLOSEDOFFICEIRP: (state,data) =>{
      state.closedOfficeIRP = data
    },
    SET_CLOSEDOFFICELT: (state,data) =>{
      state.closedOfficeLT = data
    },

    SET_CLOSEDOFFICEKIOSKDL: (state,data) =>{
      state.closedOfficeKioskDL = data
    },
    SET_CLOSEDOFFICEKIOSKVR: (state,data) =>{
      state.closedOfficeKioskVR = data
    },

    SET_CLOSEDOFFICEKIOSKDLVR: (state,data) =>{
      state.closedOfficeKioskDLVR = data
    },

    */
  }

})
